import { render } from "./ResidentCard.vue?vue&type=template&id=29f0d684"
import script from "./ResidentCard.vue?vue&type=script&lang=js"
export * from "./ResidentCard.vue?vue&type=script&lang=js"

import "./ResidentCard.vue?vue&type=style&index=0&id=29f0d684&lang=scss"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__